import { NotificationState } from '../types/notifications'

const notificationsInitialState: NotificationState = {
  notifications: [],
  unreadCount: 0,
  isConnected: false,
  loading: false,
  error: null,
}

export default notificationsInitialState
